module.exports = require('react/lib/ReactTransitionGroup');


/*****************
 ** WEBPACK FOOTER
 ** ../kettle-ui/~/react-addons-transition-group/index.js
 ** module id = 516
 ** module chunks = 0
 **/